export const highlightOnFocus = {
  dataSet: { focusable: true },
} as any;

export const webHighlightOnFocus = {
  "data-focusable": true,
} as any;
